import React, { useState } from 'react';
import { useNCZIContext } from '../../Services/NCZIContext';
import NCZICommandResult from '../NCZICommandResult/NCZICommandResult';
import useNCZI from '../../Hooks/useNCZI';
import { useEffectAsync } from '../../../../helpers';
import CompareInformations from './CompareInformations';
import { usePatientTreatmentContext } from '../../../Patient/Components/PatientTreatment/ContextProvider';

interface Props {
	onClose: () => void;
}

const PatientVerifyInformations: React.FC<Props> = ({ onClose }) => {
	const { patientId } = usePatientTreatmentContext();
	const { patientSummaryContactData, patientIdentifier } = useNCZIContext();
	const { fetchPatientSummaryContactData } = useNCZI();
	const [loadingCommandId, setLoadingCommandId] = useState<string | undefined>(
		undefined,
	);

	const handleLoadPatientContactData = async () => {
		if (patientIdentifier) {
			const command = await fetchPatientSummaryContactData(
				patientIdentifier,
				patientId,
			);
			if (command.id) {
				setLoadingCommandId(command.id);
			}
		}
	};

	const handleLoadData = async () => {
		if (!patientSummaryContactData) {
			await handleLoadPatientContactData();
		}
	};

	useEffectAsync(async () => {
		await handleLoadData();
	});

	if (!patientSummaryContactData || !patientIdentifier) {
		return (
			<NCZICommandResult
				commandId={loadingCommandId}
				handleRetryCommand={handleLoadData}
			/>
		);
	}

	return (
		<>
			{patientSummaryContactData.patientJRUZ && (
				<CompareInformations
					jruz={patientSummaryContactData.patientJRUZ}
					onClose={onClose}
				/>
			)}
		</>
	);
};

export default PatientVerifyInformations;
